<template>
  <div
    v-if="existingCompanyLinks.length"
    class="sf-tab"
    data-walkthrough-id="company-links-overview"
    data-testid="company-links-overview"
  >
    <div
      v-for="companyLink in existingCompanyLinks"
      :key="companyLink.id"
      data-testid="existing-company-link"
    >
      <div class="sf-tab-item sf-level-between sf-level sf-pad-h-2">
        <ExternalCompanyLabel
          :company-id="companyLink.sourceCompanyId"
          :company-name="companyLink.sourceCompanyName"
          :created-by="companyLink.createdBy"
          :created-at="companyLink.createdAt"
        />
        <div class="sf-level-item">
          <SfButtonDs
            variant="secondary"
            size="sm"
            icon-only
            icon-before="trash-can"
            :aria-label="I18n.t('company_links.destroy.delete_link')"
            :data-testid="'delete_' + companyLink.id"
            @click="onDeleteCompanyLink(companyLink)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { ExistingCompanyLink } from '../types'

import ExternalCompanyLabel from '@app/application/company_links/components/external-company-label.vue'

import { storeToRefs } from 'pinia'
import { useCompanyLinksStore } from '@app/application/company_links/store/use-company-links'
import { SfButtonDs } from '@silverfin/ui-components'

const I18n = useI18n()

interface Props {
  modalMode: boolean
}
const { modalMode } = defineProps<Props>()

const companyLinksStore = useCompanyLinksStore()

if (!modalMode) {
  companyLinksStore.initExistingCompanyLinks()
}

const { existingCompanyLinks } = storeToRefs(companyLinksStore)

function onDeleteCompanyLink(companyLink: ExistingCompanyLink): void {
  companyLinksStore.markLinkForDeletion(companyLink)
}
</script>
